import { EventGameOutcomeTypeEnum } from "../../EventGameFixturesModel";
import { PredictionType } from "../PredictionType";

export default class EventGameFixtures<
  T extends EventGameOutcomeTypeEnum = EventGameOutcomeTypeEnum
> {
  public id: string = "";
  public predictionType: T;
  public prediction: PredictionType<T>;
}
